export default __webpack_public_path__ + "static/media/kuesioner.3d99448b.png";